import m from "mithril";
const messageUrl = "/lang/{locale}.json";
// https://medium.com/i18n-and-l10n-resources-for-developers/localizing-mithril-applications-728fca63eaf3
// https://github.com/PhraseApp-Blog/mithriljs-i18n-2021.git
import Datepicker from 'vanillajs-datepicker/Datepicker';
import es from 'vanillajs-datepicker/locales/es';
import fr from 'vanillajs-datepicker/locales/fr';
import de from 'vanillajs-datepicker/locales/de';
import enAU from 'vanillajs-datepicker/locales/en-AU';
import enCA from 'vanillajs-datepicker/locales/en-CA';
import enIE from 'vanillajs-datepicker/locales/en-IE';
import ptBR from 'vanillajs-datepicker/locales/pt-BR';
//Q2 Languages:
import cs from 'vanillajs-datepicker/locales/cs';
import da from 'vanillajs-datepicker/locales/da';
import enGB from 'vanillajs-datepicker/locales/en-GB';
import hu from 'vanillajs-datepicker/locales/hu';
import nl from 'vanillajs-datepicker/locales/nl';
import pl from 'vanillajs-datepicker/locales/pl';
import pt from 'vanillajs-datepicker/locales/pt';
import fi from 'vanillajs-datepicker/locales/fi';
import it from 'vanillajs-datepicker/locales/it';
import ro from 'vanillajs-datepicker/locales/ro';
import SessionController from "../session";

const SUPPORTED_LOCALES = [
    {display: 'العربية', code: 'ar-001', disable: true, countryCode: 'AE'},
    {display: 'čeština', code: 'cs-CZ', disable: false, countryCode: 'CZ'},
    {display: 'dansk', code: 'da-DK', disable: false, countryCode: 'DK'},
    {display: 'Deutsch (Deutschland)', code: 'de', disable: false, countryCode: 'DE'},
    {display: 'English (Australia)', code: 'en-AU', disable: false, countryCode: 'AU'},
    {display: 'English (Canada)', code: 'en-CA', disable: false, countryCode: 'CA'},
    {display: 'English (United Kingdom)', code: 'en-GB', disable: false, countryCode: 'GB'},
    {display: 'English (United States)', code: 'en-US', disable: false, countryCode: 'US'},
    {display: 'español (España)', code: 'es', disable: false, countryCode: 'ES'},
    {display: 'español (Latinoamérica)', code: 'es-419', disable: false, countryCode: 'ES'},
    {display: 'suomi', code: 'fi-FI', disable: false, countryCode: 'FI'},
    {display: 'Filipino/Tagalog (Pilipinas)', code: 'fp-PH', disable: true, countryCode: 'PH'},
    {display: 'français (Canada)', code: 'fr-CA', disable: false, countryCode: 'CA'},
    {display: 'français (France)', code: 'fr', disable: false, countryCode: 'FR'},
    {display: 'हिन्दी', code: 'hi-IN', disable: true, countryCode: 'IN'},
    {display: 'magyar', code: 'hu-HU', disable: false, countryCode: 'HU'},
    {display: 'Bahasa Indonesia', code: 'id-ID', disable: true, countryCode: 'ID'},
    {display: 'italiano (Italia)', code: 'it-IT', disable: false, countryCode: 'IT'},
    {display: '日本語', code: 'ja-JP', disable: true, countryCode: 'JP'},
    {display: '한국어', code: 'ko-KR', disable: true, countryCode: 'KR'},
    {display: 'Bahasa Melayu', code: 'ms-MY', disable: true, countryCode: 'MY'},
    {display: 'Nederlands (Nederland)', code: 'nl-NL', disable: false, countryCode: 'NL'},
    {display: 'Norsk (Bokmål)', code: 'nb-NO', disable: false, countryCode: 'NO'},
    {display: 'polski', code: 'pl-PL', disable: false, countryCode: 'PL'},
    {display: 'Íslenska', code: 'is-IS', disable: false, countryCode: 'IS'},
    {display: 'português (Brasil)', code: 'pt-BR', disable: false, countryCode: 'BR'},
    {display: 'português (Portugal)', code: 'pt-PT', disable: false, countryCode: 'PT'},
    {display: 'română', code: 'ro-RO', disable: false, countryCode: 'RO'},
    {display: 'slovenčina', code: 'sk-SK', disable: true, countryCode: 'SK'},
    {display: 'svenska', code: 'sv-SE', disable: true, countryCode: 'SE'},
    {display: 'ไทย', code: 'th-TH', disable: true, countryCode: 'TH'},
    {display: 'Türkçe', code: 'tr-TR', disable: true, countryCode: 'TR'},
    {display: 'Tiếng Việt', code: 'vi-VN', disable: true, countryCode: 'VN'},
    {display: '简体中文', code: 'zh-CN', disable: true, countryCode: 'CN'},
    {display: '中文（繁體）', code: 'zh-TW', disable: true, countryCode: 'TW'}
]
Object.assign(Datepicker.locales, es, fr, de, enAU, enCA, enIE, ptBR, cs, da, enGB, hu, nl, pl, pt, fi, it, ro);
Datepicker.locales['ro-RO'] = Datepicker.locales['ro'];
//TODO Create a map for following languages. These languages locale keys are different from datepicker keys:
// cs-CZ, da-DK, en-CA, en-GB, en-US, es-419, fr-CA, hu-HU, nl-NL, pl-PL, pt-BR, pt-PT, fi-FI, it-IT
//Above locales to be mapped to datePicker keys as following: cs, da, enCA, enGB, enIE, es, fr, hu, nl, pl, pt, fi, it

function t(key, variables = {}, defaultValue) {
    if (i18n && i18n.messages) {
        let message = i18n.messages[key] || defaultValue || key;

        Object.keys(variables).forEach(variable => {
            const regex = new RegExp(`{{${variable}}}`, 'g');
            message = message.replace(regex, variables[variable]);
        });

        return message;
    } else {
        return defaultValue || key;
    }
}

// Like t(), but nodeMap values are Mithril vnodes inserted at {{placeholder}} positions.
// Returns an array suitable for use as Mithril children.
function tWithNodes(key, nodeMap = {}, defaultValue) {
    const message = (i18n && i18n.messages && (i18n.messages[key] || defaultValue || key)) || defaultValue || key;
    return message.split(/({{[^}]+}})/).map(part => {
        const match = part.match(/^{{(.+)}}$/);
        return (match && nodeMap[match[1]] !== undefined) ? nodeMap[match[1]] : part;
    });
}

function setLocale() {
    const hashQuery = window.location.hash.split("?")[1];
    const urlLocale = hashQuery ? new URLSearchParams(hashQuery).get("locale") : null;
    if (urlLocale && SUPPORTED_LOCALES.some(l => l.code === urlLocale && !l.disable)) {
        loadAndSetLocale(urlLocale);
        return;
    }

    const storageLocale = window.localStorage.getItem("preferred-locale");

    if (storageLocale) {
        loadAndSetLocale(storageLocale);
    } else {
        let sessionReady = SessionController.session && SessionController.session.environment;
        if (!sessionReady) {
            SessionController.getSession().finally(() => {
                let defaultOrgLocale = (SessionController.session && SessionController.session.environment && SessionController.session.environment.locale)
                    ? SessionController.session.environment.locale
                    : 'en-AU';
                loadAndSetLocale(defaultOrgLocale);
            })
        } else {
            loadAndSetLocale(SessionController.session.environment.locale)
        }
    }
}

function loadAndSetLocale(newLocale) {
    console.log('loading locale file, for locale:', newLocale)
    if (i18n.locale === newLocale) {
        return;
    }
    fetchMessages(newLocale, (messages) => {
        // Convert all keys in the messages object to lowercase
        const lowerCaseMessages = Object.fromEntries(
            Object.entries(messages).map(([key, value]) => [key.toLowerCase(), value])
        );

        i18n.messages = new Proxy(lowerCaseMessages, {
            get: function(target, name) {
                return target[typeof name === 'string' ? name.toLowerCase() : name];
            },
            set: function(target, name, value) {
                target[typeof name === 'string' ? name.toLowerCase() : name] = value;
                return true;
            }
        }); // Use a Proxy to Handle Case Insensitivity
        i18n.locale = newLocale;
        i18n.countryCode = SUPPORTED_LOCALES.find(x => x.code == newLocale).countryCode,
        window.localStorage.setItem("preferred-locale", newLocale);
    });
}

function getCurrentLocale() {
    const storageLocale = window.localStorage.getItem("preferred-locale");

    if (storageLocale) {
        return storageLocale;
    } else {
        let sessionReady = SessionController.session && SessionController.session.environment;
        let defaultOrgLocale = sessionReady ? SessionController.session.environment.locale : null;

        return defaultOrgLocale;
    }
}

function fetchMessages(locale, onComplete) {
    let url_ = messageUrl.replace("{locale}", locale);
    console.log('fetching locale:', url_);
    m.request(url_).then(
        onComplete,
    );
}

function getLanguageSelectorTitle() {
    let locale = i18n.locale;
    if (locale) {
        if (locale === 'en-AU') {
            return 'English (Australia)';
        }
        if (locale === 'en-CA') {
            return 'English (Canada)';
        }
        if (locale === 'en-US') {
            return 'English (United States)';
        }
        if (locale === 'en-GB') {
            return 'English(United Kingdom)';
        }
        if (locale === 'pt-BR') {
            return 'português (Brasil)';
        }
        if (locale === 'pt-PT') {
            return 'português (Portugal)';
        }
        if (locale === 'cs-CZ') {
            return 'čeština';
        }
        if (locale === 'da-DK') {
            return 'dansk';
        }
        if (locale === 'de') {
            return 'Deutsch (Deutschland)';
        }
        if (locale === 'hu-HU') {
            return 'magyar';
        }
        if (locale === 'nl-NL') {
            return 'Nederlands (Nederland)';
        }
        if (locale === 'pl-PL') {
            return 'polski';
        }
        if (locale === 'is-IS') {
            return 'Íslenska';
        }
        if (locale === 'nb-NO') {
            return 'Norsk (Bokmål)';
        }
        if (locale === 'fi-FI') {
            return 'suomi';
        }
        if (locale === 'it-IT') {
            return 'italiano (Italia)';
        }
        if (locale === 'es-419') {
            return 'español (Latinoamérica)';
        }
        if (locale === 'es') {
            return 'español (España)';
        }
        if (locale === 'fr-CA') {
            return 'français (Canada)';
        }
        if (locale === 'fr') {
            return 'français (France)';
        }
        if (locale === 'ro-RO') {
            return 'română';
        }
    } else {
        return i18n.t('language_selector');
    }
}

function isSelectedLanguageCode(code) {
    return i18n.locale === code;
}

const i18n = {
    supportedLocales: SUPPORTED_LOCALES,
    locale: null,
    messages: {}, // loadAndSetLocale() populates these
    countryCode: null,
    t,
    tWithNodes,
    loadAndSetLocale,
    getCurrentLocale,
    setLocale,
    getLanguageSelectorTitle,
    isSelectedLanguageCode
};

export default i18n;
